import React, { FC } from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import { PointsBalance as UIFoundationsPointsBalance } from '@dcxwam/dcx-wam-ui-foundations'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import VisibilityGate from '../../functional/VisibilityGate/VisibilityGate'
import { PointsBalanceModelProps } from './types'
import usePointsBalance from '../../../hooks/usePointsBalance'

const MOCK_POINTS_BALANCE = 1536
const MOCK_MEMBERSHIP_GROUP = '3|6'

const PointsBalance: FC<EditableComponentPropsType<PointsBalanceModelProps>> = (
  props
) => {
  const { isInEditor, model } = props
  const { showPoints, membershipStatusLabel, visibleTo, cta } = model
  const { pointsBalance, membershipGroup } = usePointsBalance()
  const displayPointsBalance = isInEditor
    ? MOCK_POINTS_BALANCE
    : (pointsBalance ?? 0)
  const displayMembershipGroup = isInEditor
    ? MOCK_MEMBERSHIP_GROUP
    : membershipGroup

  if (!showPoints || !cta?.label) {
    return <EditableComponent {...props}>{null}</EditableComponent>
  }

  return (
    <EditableComponent {...props}>
      <VisibilityGate visibleTo={visibleTo}>
        <UIFoundationsPointsBalance
          className="cmp-points-balance"
          label={cta.label}
          pointsBalance={displayPointsBalance}
          pointsLabel={cta.pointsLabel}
          membershipStatusLabel={membershipStatusLabel}
          membershipStatus={displayMembershipGroup}
          targetUrl={cta.url}
          ariaLabel={cta.ariaLabel}
          buttonClassName={cta.additionalClasses}
        />
      </VisibilityGate>
    </EditableComponent>
  )
}

export default PointsBalance
